import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { brandsAPI } from '../services/api';
import './Users.css';

const Brands = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [search, setSearch] = useState('');
  const [searchDebounced, setSearchDebounced] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setSearchDebounced(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  const loadBrands = useCallback(async () => {
    setLoading(true);
    try {
      const params = { limit: searchDebounced ? 50 : 100 };
      if (searchDebounced) params.search = searchDebounced;
      const response = await brandsAPI.getAll(params);
      setBrands(response.data?.brands || []);
    } catch (error) {
      toast.error('Error loading brands: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  }, [searchDebounced]);

  useEffect(() => {
    void loadBrands();
  }, [loadBrands]);

  const openCreate = () => {
    navigate('/brands/new');
  };

  const openEdit = (brand) => {
    navigate(`/brands/${brand.id}/edit`);
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this brand?')) return;
    try {
      await brandsAPI.delete(id);
      toast.success('Brand deleted');
      await loadBrands();
    } catch (error) {
      toast.error('Error deleting brand: ' + (error.response?.data?.message || error.message));
    }
  };

  return (
    <div className="users-container">
      <div style={{ marginBottom: 20, display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          type="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search brands…"
          style={{
            flex: '1 1 220px',
            minWidth: 200,
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid #ddd',
          }}
        />
        <button type="button" className="btn btn-primary" onClick={openCreate}>
          + Add Brand
        </button>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Brand</th>
              <th>Arabic</th>
              <th>Sort</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: 20 }}>
                  Loading...
                </td>
              </tr>
            ) : brands.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: 20 }}>
                  {searchDebounced ? 'No brands match your search.' : 'No brands found.'}
                </td>
              </tr>
            ) : (
              brands.map((brand) => (
                <tr key={brand.id}>
                  <td>{brand.name}</td>
                  <td>{brand.name_ar || '—'}</td>
                  <td>{brand.sort_order ?? 0}</td>
                  <td>{brand.is_active ? 'Active' : 'Inactive'}</td>
                  <td className="actions">
                    <button type="button" className="btn btn-primary" onClick={() => openEdit(brand)}>
                      Edit
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => remove(brand.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Brands;
